import { motion, AnimatePresence } from "framer-motion";
import { MOVES, moveLabel } from "@/lib/format";

export const FlagMarker = ({ flag, onPull, busy }) => (
  <AnimatePresence>
    {flag && (
      <motion.button
        key={flag.id}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
        onClick={() => onPull(flag.id)}
        disabled={busy}
        title="A background check found something. Click to ask the Observer about it."
        className="group flex items-center gap-2 h-10 px-3 border border-[var(--o-border)] hover:border-[#FF3B30] hover:bg-[#FF3B30]/5 disabled:opacity-50 transition-colors"
        data-testid="flag-marker"
      >
        <span className="relative flex h-2.5 w-2.5">
          <span className="listen-ring absolute inline-flex h-full w-full rounded-full bg-[#FF3B30]" />
          <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-[#FF3B30]" />
        </span>
        <span className="font-mono text-[11px] uppercase tracking-[0.12em]" style={{ color: MOVES[flag.move]?.color || "var(--o-fg)" }} data-testid="flag-marker-move">
          {moveLabel(flag.move)}
        </span>
      </motion.button>
    )}
  </AnimatePresence>
);
